"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("next-auth/react");
const AuthGate_1 = require("../AuthGate");
const SessionProvider = ({ children, pageOptions, ...props }) => {
    const isPublicPage = pageOptions?.isPublic ?? false;
    return ((0, jsx_runtime_1.jsx)(react_1.SessionProvider, { ...props, children: isPublicPage ? (children) : ((0, jsx_runtime_1.jsx)(AuthGate_1.AuthGate, { ...pageOptions, children: children })) }));
};
exports.SessionProvider = SessionProvider;
